/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_viewer = {
    readonly isPdpStfEnabled?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
    readonly " $refType": "PdpSharedIconBubbleEmail_viewer";
};
export type PdpSharedIconBubbleEmail_viewer$data = PdpSharedIconBubbleEmail_viewer;
export type PdpSharedIconBubbleEmail_viewer$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleEmail_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpStfEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "enablePdpStf"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"enablePdpStf\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSendToFriendModalLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'f4c0984c1d3795fc70c1068b9baf81be';
export default node;
